import React, { createContext, useContext, useState, useCallback } from 'react';

// Global background-render jobs that persist across navigation.
// jobs: [{ id, status: 'rendering'|'done'|'error', name, file?, error?, startedAt }]

const RenderJobsContext = createContext({
  jobs: [],
  startJob: () => {},
  setJobStatus: () => {},
  dismissJob: () => {},
  setPreviewFile: () => {},
  previewFile: null,
});

export const RenderJobsProvider = ({ children }) => {
  const [jobs, setJobs] = useState([]);
  const [previewFile, setPreviewFile] = useState(null);

  const startJob = useCallback((id, name) => {
    setJobs(prev => [...prev, { id, status: 'rendering', name, startedAt: Date.now() }]);
  }, []);

  const setJobStatus = useCallback((id, updates) => {
    setJobs(prev => prev.map(j => j.id === id ? { ...j, ...updates } : j));
  }, []);

  const dismissJob = useCallback((id) => {
    setJobs(prev => prev.filter(j => j.id !== id));
  }, []);

  return (
    <RenderJobsContext.Provider value={{
      jobs, startJob, setJobStatus, dismissJob,
      previewFile, setPreviewFile,
    }}>
      {children}
    </RenderJobsContext.Provider>
  );
};

export const useRenderJobs = () => useContext(RenderJobsContext);
